import { OrderTracking } from '@/types';
import { formatDateTime } from '@/utils';
import { CheckCircle, Clock, Package, Truck, Home, XCircle } from 'lucide-react';

const STATUS_ICONS: Record<string, React.ElementType> = {
  PENDING: Clock,
  CONFIRMED: CheckCircle,
  PROCESSING: Package,
  SHIPPED: Truck,
  DELIVERED: Home,
  CANCELLED: XCircle,
  REFUNDED: XCircle,
};

interface Props {
  tracking: OrderTracking[];
}

export const OrderTrackingTimeline = ({ tracking }: Props) => (
  <div className="space-y-0">
    {tracking.map((event, i) => {
      const Icon = STATUS_ICONS[event.status] || Clock;
      const isLast = i === tracking.length - 1;
      return (
        <div key={event.id} className="flex gap-4">
          <div className="flex flex-col items-center">
            <div className={`w-9 h-9 rounded-full flex items-center justify-center z-10 ${i === 0 ? 'bg-primary-500 text-white' : 'bg-primary-100 text-primary-600'}`}>
              <Icon className="h-4 w-4" />
            </div>
            {!isLast && <div className="w-0.5 h-8 bg-primary-200 my-1" />}
          </div>
          <div className="pb-6">
            <p className="font-semibold text-gray-800 capitalize">{event.status.toLowerCase()}</p>
            {event.description && <p className="text-sm text-gray-500">{event.description}</p>}
            <p className="text-xs text-gray-400 mt-1">{formatDateTime(event.timestamp)}</p>
          </div>
        </div>
      );
    })}
  </div>
);
